// Services
import breedersService from "@/app/services/main/breeders/breeders-service.js"
import addressFinderAutocompleteService from "@/app/services/address-finder/address-finder-autocomplete/address-finder-autocomplete-service.js"
import breedService from "@/app/services/main/breed/breed-service.js"
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js"

// Utils
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { imageCompressorMixins } from "@/app/mixins/utils/image-compressor-mixins"
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins"
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"

// Constants
import { STATUS_CODES, SUCCESS_MSG, PUPPY_SELL_STATUS } from "@/app/constants/status-constants"
import { STATES } from "@/app/constants/state-constants.js"
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

// Component
const FileUpload = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "file-upload" */ "@/app/views/main-view/_shared/_components/file-upload/file-upload.vue"
	)
const SellPuppyList = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "sell-puppy-list" */ "@/app/views/main-view/sell-your-dog/components/sell-puppy-list/sell-puppy-list.vue"
	)

export default {
	name: "SellYourDogContainer",
	components: { FileUpload, SellPuppyList },
	mixins: [toastMessageMixins, imageCompressorMixins, inputTextMixins, userMixins, tableMixins],
	data() {
		return {
			SELL_YOUR_PUPPY_INFO: BREEDER_ROUTES.SELL_YOUR_PUPPY_INFO,
			BREEDER_BIO: BREEDER_ROUTES.BREEDER_BIO,

			// Breeder Details
			breederDetails: {
				breederSysId: "",
				breederId: "",
				state: "",
				name: "",
				emailAddress: "",
				mobileNumber: "",
				address: "",
				fullAddress: "",
				postcode: "",
				suburb: "",
				status: "DEACTIVATED",
				companyName: "",
			},
			addressData:{},
			breederList: [],
			isBreederAvailable: false,
			verified: false,
			status: "",
			reason: "",
			breederDataId: null,
			isDetailsUpdated: false,
			isShowMore: false,
			puppySellTotalCount: 0,
			didDeletePuppy: false, 

			// Image upload
			imageToCrop: "",
			imageSrc: "",
			fileBlob: null,
			isImageChanged: false,

			// States
			stateOptions: [
				{
					value: "NSW",
					option: "New South Wales",
				},
				{
					value: "VIC",
					option: "Victoria",
				},
				{
					value: "QLD",
					option: "Queensland",
				},
				{
					value: "WA",
					option: "Western Australia",
				},
				{
					value: "SA",
					option: "South Australia",
				},
				{
					value: "TAS",
					option: "Tasmania",
				},
				{
					value: "NT",
					option: "Northern Territory",
				},
				{
					value: "ACT",
					option: "Australian Capital Territory",
				},
			],

			// Address List
			addressList: [],
			isAddressLoading: false,

			// Loading
			isAPILoading: false,
			isPuppyLoading: true,

			// Mobile Number Format
			mobileNumberIsValid: true,
			breederMobileNumberIsValid: true,

			//Puppy List
			puppyList: [],

			//Temp data
			tmpBreederId: "",
			tmpState: "",
			tmpName: "",
			tmpEmailAddress: "",
			tmpMobileNumber: "",
			tmpAddress: "",
			tmpCompanyName: "",
			breederDetailOld: {
				breederId: "",
				state: "",
				name: "",
				emailAddress: "",
				mobileNumber: "",
				address: "",
				companyName: "",
			},
			lmdcWidgetUrl: `${window.location.origin}/widget/lmdc-widget.html`,
			iframeCode: `<iframe src="${window.location.origin}/widget/lmdc-widget.html" height="170" width="330" title="Love My Dog Club" frameborder="0"></iframe>`,
			copyTextContent: "Copy",

			selectedStatus: "",
			statusOptions: [
				{
					value: "P",
					name: "PENDING",
				},
				{
					value: "A",
					name: "AVAILABLE",
				},
				{
					value: "S",
					name: "SOLD",
				},
				{
					value: "PENDING_PAYMENT",
					name: "PENDING PAYMENT",
				},
				{
					value: "REQUEST_REFUND",
					name: "REQUEST FOR REFUND",
				},
				{
					value: "REFUNDED",
					name: "REFUNDED",
				},
				{
					value: "PICKED_UP",
					name: "PICKED UP",
				},
				{
					value: "HIDDEN",
					name: "HIDDEN",
				},
			],
			isFiltered: false,
		}
	},
	watch: {
		breederDetails: {
			handler(newValue, oldValue) {
				for (const key in newValue) {
					if (newValue.hasOwnProperty(key)) {
					  const newVal = newValue[key];
					  const oldVal = this.breederDetailOld.hasOwnProperty(key) ? this.breederDetailOld[key] : undefined;
					   
					  if(this.breederDetailOld.hasOwnProperty(key)) {
							// Convert both values to strings for comparison
							if (String(newVal) !== String(oldVal)) {
								this.isDetailsUpdated = String(newVal) !== String(oldVal)
								break; // Exit after handling the first detected change
							}
					  }
					 
					}
				}
			},
			deep: true, // This ensures that the watcher is triggered for nested changes
		  },
	},
	async created() {
		await this.getBreederDetails()
		// await this.getBreederList()
	},

	computed: {
		hasImage() {
			return !!this.imageSrc
		},

		selectedState() {
			let state = ""

			if (this.breederDetails.state) {
				state = STATES[this.breederDetails.state]
			} else {
				state = "Select State"
			}

			return state
		},

		validationRules() {
			let fields = {
				breederDetails: {
					breederId: {},
					state: {},
					name: {},
					emailAddress: {},
					mobileNumber: {},
					address: {},
					companyName: {},
				},
				addressData:{}
			}

			fields.addressData = vuelidateUtil.setFieldsRequired(fields.addressData, true)
			fields.breederDetails = vuelidateUtil.setFieldsRequired(fields.breederDetails, true)
			fields.breederDetails = vuelidateUtil.setEmailValidation(fields.breederDetails, "emailAddress")

			return fields
		},

		isDisabled() {
			return this.$v.$invalid || this.isAPILoading
		},

		verifiedStatus() {
			return this.verified ? "Verified Breeder" : "Unverified Breeder"
		},
		displayBreederApprovalNextStep() {
			return (
				(!this.verified && this.breederDataId && this.puppyList.length === 0 && !this.isFiltered) ||
				(this.verified && this.breederDataId && this.puppyList.length === 0 && !this.isFiltered)
			)
		},
		breederDeactivated() {
			return this.status === "DEACTIVATED" || this.status === "FOR_REACTIVATION"
		},
		enableField() {
			return this.status === "P" || this.status === "DEACTIVATED" || this.status === "FOR_REACTIVATION"
		},

		displayShowMoreButton() {
			return this.puppySellTotalCount != this.puppyList.length
		},
		userDetails() {
			return this.getUserDetails()
		},

		breederVerifiedStatus() {
			return this.verified
		}
	},

	methods: {
		getTableContent(page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			this.getUserPuppySellList({ page, limit: 9, sortBy, desc: true })
		},
		async getBreederDetails() {
			const { id: userId } = this.getUserDetails();

			try {
				this.isAPILoading = true
				const response = await breedersService.getBreederByUserId(userId);
				if (response.status === 200) {
					const responseData = response.data;
					// Set details from API
					this.$store.commit("setBreederDetails", { breederSysId: responseData.id, name: responseData.name })
					
					this.breederDetails.breederSysId = responseData.id
					this.breederDetails.breederId = responseData.code
					this.breederDetails.name = responseData.name
					this.breederDetails.state = responseData.state
					this.breederDetails.emailAddress = responseData.email
					this.breederDetails.mobileNumber = responseData.mobileNumber.replace(/(....)(......)/g, "$1-$2")
					this.breederDetails.address = responseData.address
					this.breederDetails.fullAddress = responseData.address
					this.addressData.displayAddress = responseData.displayAddress
					this.breederDetails.address = responseData.displayAddress
					this.breederDetails.postcode = responseData.postcode
					this.breederDetails.suburb = responseData.suburb
					
					this.breederDetails.companyName = responseData.companyName
					this.imageSrc = responseData.imageUrl
					this.verified = responseData.verified
					this.status = responseData.status
					this.breederDataId = responseData.id
					this.reason = responseData.reason

					//Set Temp data
					this.tmpBreederId = responseData.code
					this.tmpState = responseData.state
					this.tmpName = responseData.name
					this.tmpEmailAddress = responseData.email
					this.tmpMobileNumber = responseData.mobileNumber.replace(/(....)(......)/g, "$1-$2")
					this.tmpAddress = responseData.address
					this.tmpCompanyName = responseData.companyName

					this.breederDetailOld.breederId = this.tmpBreederId
					this.breederDetailOld.state = this.tmpState
					this.breederDetailOld.name = this.tmpName
					this.breederDetailOld.emailAddress = this.tmpEmailAddress
					this.breederDetailOld.mobileNumber = this.tmpMobileNumber
					this.breederDetailOld.address = responseData.displayAddress
					this.breederDetailOld.companyName = this.tmpCompanyName
					
					this.isBreederAvailable = true
					this.isAPILoading = false

					this.lmdcWidgetUrl = `${window.location.origin}/widget/lmdc-widget.html?breedSysId=${this.breederDetails.breederSysId}`,
					this.iframeCode = `<iframe src="${window.location.origin}/widget/lmdc-widget.html?breedSysId=${this.breederDetails.breederSysId}" height="170" width="330" title="Love My Dog Club" frameborder="0"></iframe>`,
			

					// fetch list of puppies, moved this here so it will be called ONLY if the user is a breeder (instead of calling it in the created function) 
					await this.getTableContent()

					this.$store.commit('setHasSwitchToBreederRole', true);
				} else {
					this.isBreederAvailable = false
					this.isAPILoading = false

					// this is needed here to handle the deletion of breeder details on the admin side
					this.$store.commit('setHasSwitchToBreederRole', false);
				}
			} catch (err) {
				// Catch any error
				this.isAPILoading = false
			}
		},

		async saveBreederDetails() {
			if (this.$v.$invalid || !this.mobileNumberIsValid) {
				return
			}

			try {
				this.isAPILoading = true
				// Get Breeder Details
				let formattedAddress = this.breederDetails.fullAddress
				let breederDetails = {
					formDetails: {
						...this.breederDetails,
						address: formattedAddress,
						mobileNumber: this.breederDetails.mobileNumber.replace("-", ""),
					},
					breederImg: this.fileBlob ? this.fileBlob[0] : this.isBreederAvailable ? this.imageSrc : "",
				}

				// Call API for register breeder
				const response = await breedersService.registerBreeder(breederDetails)

				if (response.status === STATUS_CODES.SUCCESS) {
					// Refresh Breeder Details and Call Success Toast
					this.isDetailsUpdated = false
					this.isImageChanged = false
					this.getBreederDetails()
					const { SUCCESS_BREEDER_REGISTERED } = this.toastMessages.breeder()
					this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_BREEDER_REGISTERED)
					this.isAPILoading = false

					this.$store.commit('setHasSwitchToBreederRole', true);
				} else {
					// Call Error Toast
					this.showAPIErrorToast(response.data.errors[0].message, response)
					this.isAPILoading = false

					this.$store.commit('setHasSwitchToBreederRole', false);
				}
			} catch (err) {
				// Catch any error
				this.showGenericErrorToast()
				this.isAPILoading = false
			}
		},

		onSelectedState(state) {
			this.breederDetails.state = state.value
		},

		async onBlur(field) {
			if (field === "address") {
				this.$v.addressData.$touch()
				this.$v.breederDetails.address.$touch()
				if (this.addressData) {
					await this.getAddressMetaData(this.addressData)
				}
			}
		},

		findAddress(address) {
			if (address) {
				this.isAddressLoading = true

				this.delayTyping(() => {
					this.getAutocompleteAddress(address)
				})
			}
		},

		getAutocompleteAddress(address) {
			addressFinderAutocompleteService
				.getAutocompleteAddress(address)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.addressList = res.data.completions.map((item) => {
							let tempAddress = item.full_address
							item.displayAddress = tempAddress
							item.label = item.id
							return item
						})
						this.isAddressLoading = false
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder()
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res)
						this.isAddressLoading = false
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAddressLoading = false
				})
		},

		async setSelectedAddress() {
			this.$v.addressData.$touch()

			if (this.addressData) {
				await this.getAddressMetaData(this.addressData)
			}
		},

		async getAddressMetaData(address) {
			addressFinderAutocompleteService
				.getAddressMetaData(address.id)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const { locality_name, postcode, full_address } = res.data
						this.addressData.displayAddress = locality_name + " " + postcode
						this.breederDetails.address = locality_name + " " + postcode
                        this.breederDetails.fullAddress = full_address
                        this.breederDetails.postcode = postcode
                        this.breederDetails.suburb = locality_name
						this.isAddressLoading = false
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder()
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res)
						this.isAddressLoading = false
					}
				})
				.catch((err) => {
					this.showGenericErrorToast()
					this.isAddressLoading = false
				})
		},

		async onUploadImage(event) {
			let valid = this.validateImage(event.target.files[0])

			// compress image if more than 2mb
			const file = await this.compressImage(event.target.files[0])

			// do nothing when user cancels Upload
			if (!valid) {
				// reset uploader
				this.$refs.uploader.value = ""
				return
			}

			this.fileBlob = [file]

			// show preview of pet image
			let reader = new FileReader()
			reader.onload = () => {
				this.imageToCrop = reader.result
				this.$refs.modalFileUpload.show()
			}

			reader.readAsDataURL(file)
		},

		setImageCrop({ image, blob }) {
			this.isImageChanged = true
			this.imageSrc = image
			this.fileBlob = blob
		},

		clearFileInput(event) {
			event.target.value = ""
		},
		onPasteMobileNumber(event) {
			event.preventDefault(); // Prevent default paste behavior
			const pastedText = event.clipboardData.getData('text/plain');

			const formatMobileNumberOnPaste = this.formatMobileNumberOnPaste(pastedText)
			event.target.value = formatMobileNumberOnPaste;
		},
		mobileNumberFormat(event, isBreeder) {
			this.mobileNumberIsValid = true

			const formattedValue = this.formatMobileNumberOnChange(event);

			if (isBreeder) {
				this.breederDetails.mobileNumber = formattedValue;
			} else {
				this.fields.mobileNumber = formattedValue;
			}
		},

		checkFormat() {
			let mobileNumber = this.breederDetails.mobileNumber
			let validMobile = this.breederMobileNumberIsValid

			this.$v.breederDetails.mobileNumber.$touch()

			let regexp = /^\d{4}-\d{6}$/

			if (mobileNumber !== null && mobileNumber !== "") {
				validMobile = regexp.test(mobileNumber)
			} else {
				validMobile = true
			}

			this.mobileNumberIsValid = validMobile
		},
		checkOptionID(option) {
			if (typeof option.id === "string") {
				return option.id ? option.id.substring(0, 2) : false
			}

			return false
		},
		createOptionBreeder(breedId) {
			this.addedBreederId = breedId
			return { code: breedId, name: "", id: `0⁋${breedId}` }
		},
		findBreeder(search, loading) {
			if (search) {
				loading(true)
				this.getBreederList(search, loading)
			} else {
				this.getBreederList(false, loading)
			}
		},
		getBreederList(code, loading) {
			let queryParams = {
				page: 1,
				limit: 20,
				sortBy: "code",
				desc: false,
			}

			if (code) {
				queryParams["f_code"] = code
			}

			breedService.getBreeders(queryParams).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.breederList = res.data.data
				}

				if (loading) {
					loading(false)
				}
			})
		},
		setSelectedBreeder(e) {
			if (!e) {
				// To trigger the validation
				this.$v.breederDetails.name.$touch()
				this.$v.breederDetails.mobileNumber.$touch()
				this.$v.breederDetails.emailAddress.$touch()
				this.$v.breederDetails.state.$touch()
				this.$v.breederDetails.address.$touch()
				this.$v.breederDetails.companyName.$touch()
				this.breederDetails.name = ""
				this.breederDetails.mobileNumber = ""
				this.breederDetails.emailAddress = ""
				this.breederDetails.state = ""
				this.breederDetails.address = ""
				this.breederDetails.companyName = ""
				return
			}

			// If add breeder we will check the inputted id is existing in current breeder list
			if (!parseInt(e.id)) {
				const breeder = e.id.split("⁋")
				const breederId = breeder[1]
				const inCurrentBreeder = this.breederList.find((item) => {
					return item.code.toLowerCase() === breederId.toLowerCase()
				})

				if (inCurrentBreeder) {
					e = inCurrentBreeder
				}
			}

			this.setBreederInfo(e)
		},
		setBreederInfo(e) {
			if (e) {
				this.breederIdentifier = 0
				if (e.id && typeof e.id !== "string") {
					this.breederIdentifier = e.id
				}

				this.breederDetails.breederId = e.code ? e.code : ""
				this.breederDetails.name = e.name ? e.name : ""
				this.breederDetails.mobileNumber = e.mobileNumber
					? e.mobileNumber.replace(/(....)(......)/g, "$1-$2")
					: "" // format mobile number to 0000-000000
				this.breederDetails.emailAddress = e.email ? e.email : ""
				this.breederDetails.state = e.state ? e.state : ""
				this.breederDetails.address = e.address ? e.address : ""
			}
		},
		async getUserPuppySellList(queryParams) {
			this.isPuppyLoading = true

			const { f_status, f_sku } = this.columnsFilter

			if (f_sku) {
				queryParams["f_sku"] = f_sku
			}

			if (f_status) {
				queryParams["f_status"] = f_status
			}

			queryParams["f_breederSysId"] = this.breederDetails.breederSysId

			try {
				const response = await puppySellService.getUserPuppySellList(queryParams)
				if (response.status === STATUS_CODES.SUCCESS) {
					this.puppySellTotalCount = response.data.pagination.totalCount
					const puppyListDatas = response.data.data.map((dt) => {
						return {
							...dt,
							status: PUPPY_SELL_STATUS[dt.status],
						}
					})

					if (this.isShowMore && !this.didDeletePuppy) {
						this.puppyList = [...this.puppyList, ...puppyListDatas]
					} else {
						this.puppyList = puppyListDatas
					}
				}
			} catch (err) {
			} finally {
				this.isPuppyLoading = false
			}
		},

		processBreeder(requestType) {
			this.isAPILoading = true
			let formattedAddress = this.breederDetails.fullAddress
			const details = {
				requestDetails: {
					breeder: {
						id: this.breederDataId,
						code: this.breederDetails.breederId,
						state: this.breederDetails.state,
						name: this.breederDetails.name,
						email: this.breederDetails.emailAddress,
						mobile: this.breederDetails.mobileNumber.replace("-", ""),
						address: formattedAddress,
						suburb: this.breederDetails.suburb,
						postcode: this.breederDetails.postcode,
						companyName: this.breederDetails.companyName,
					},
					requestType,
					isDetailsUpdated: this.isDetailsUpdated,
				},
				breederImg: this.fileBlob ? this.fileBlob[0] : this.isBreederAvailable ? this.imageSrc : "",
			}

			breedersService.updateBreederDetails(details).then(async (res) => {
				if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					if (this.isDetailsUpdated) {
						this.showCustomSuccessToast(
							null,
							`Breeder details has been successfully send for verification!`
						)
					} else {
						this.showCustomSuccessToast(null, `Breeder image has been successfully updated!`)
					}
					this.isAPILoading = false
					this.isDetailsUpdated = false
					this.isImageChanged = false
					this.getBreederDetails()
				} else {
					this.showAPIErrorToast("Unable to update breeder details.", res)
					this.isAPILoading = false
				}
			})
		},

		async reactivateAccount() {
			this.isAPILoading = true
			const details = {
				id: this.breederDataId,
				status: "FOR_REACTIVATION",
			}
			const response = await breedersService.requestForReactivate(details)

			if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
				if (this.isDetailsUpdated) {
					this.showCustomSuccessToast(null, `Breeder details has been successfully send for verification!`)
				} else {
					this.showCustomSuccessToast(null, `Your reactivation request has been sent.`)
				}
				this.isAPILoading = false
				this.isDetailsUpdated = false
				this.isImageChanged = false
				this.getBreederDetails()
			} else {
				this.showAPIErrorToast("Unable to update breeder details.", response)
				this.isAPILoading = false
			}
		},

		showMore() {
			this.isShowMore = true
			this.onPageSelected("next")
		},
		async copyToClipboard() {
			if (this.copyTextContent === "Copied") {
				return // to avoid click spamming of copy button
			}

			this.copyTextContent = "Copied"

			try {
				await navigator.clipboard.writeText(this.iframeCode)
			} catch (err) {
				console.error("Failed to copy: ", err)
			}

			setTimeout(() => {
				this.copyTextContent = "Copy"
			}, 1500)
		},
		setSelectedFilter(filterBy, e) {
			this.page = 1
			const val = e ? e.value : ""
			this.isShowMore = false
			this.isFiltered = true
			this.onDropdownFilter(filterBy, val)
		},
		setSearchFilter(filterBy, e) {
			this.page = 1
			this.isShowMore = false
			this.isFiltered = true
			this.onColumnFilter(filterBy, e)
		},
		
		contactUsEmail() {
			window.location.href = "mailto:services@lovemydogclub.com.au";
		},
		onPastePuppyNumber(event) {
			const pastedText = event.clipboardData.getData('text/plain');

			// Replace any non-numeric characters
			const cleanedValue = pastedText.replace(/[^0-9]/g, '');
			event.target.value = cleanedValue;
		
			if(!isNaN(cleanedValue)){
				event.preventDefault(); // prevents the oninput from being called, making the value redundant
			}
	
			this.page = 1
			this.isShowMore = false
			this.isFiltered = true
			this.onColumnFilter("f_sku", event)
		},
		onInputChangePuppyNumber(event) {
			const inputValue = event.target.value;

			// Replace any non-numeric characters
			const cleanedValue = inputValue.replace(/[^0-9]/g, '');
			event.target.value = cleanedValue;

			if(isNaN(inputValue)){
				event.preventDefault();
				return;
			}
		
			this.page = 1
			this.isShowMore = false
			this.isFiltered = true
			this.onColumnFilter("f_sku", event)
		},
		deletePuppyInPuppyList() {
			this.didDeletePuppy = true
			this.page = 1
			this.getTableContent()
		},
		async updatePuppySellStatus(puppySellId, buyerId, status) {
			try {
				
				let htmlContent =  `<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>Are you sure you want to update the puppy status to <strong style='color: #ff801e'>${PUPPY_SELL_STATUS[status]}</strong>?</p>`
				if (PUPPY_SELL_STATUS[status] === 'AVAILABLE') {
					htmlContent =  `<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>This puppy will be displayed on the "Find a Puppy" page. Are you sure you want to <strong style='color: #ff801e'>UNHIDE</strong>?</p>`
				}
				const modalConfirmationRes = await this.$swal({
					titleText: `Update Puppy Status`,
					html: htmlContent,
					confirmButtonText: "Confirm",
					showCancelButton: true,
					cancelButtonText: "Cancel",
					reverseButtons: true,
				});

				if (modalConfirmationRes.isConfirmed) {
					this.isAPILoading = true
					const details = {
						buyerId,
						status
					};
			
					const response = await puppySellService.updatePuppyDetailsStatus(puppySellId, details);
					if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						let toastMsg = `Successfully updated Puppy selling status to ${PUPPY_SELL_STATUS[status]}`
						if (PUPPY_SELL_STATUS[status] === 'AVAILABLE') {
							toastMsg =  `Breeder has successfully unhid the puppy for viewing.`
						}
						this.showCustomSuccessToast(
							toastMsg
						);
					} else {
						const errorMessage = response.data.errors[0].message;

						if(response.status === STATUS_CODES.BAD_REQUEST){
							this.showAPIErrorToast(errorMessage, response);
						}
						else{
							this.showGenericErrorToast();
						}
					}
					this.page = 1
					this.getTableContent()
					this.isAPILoading = false
				}
			} catch (err) {
				this.showGenericErrorToast();
				this.isAPILoading = false
			}
		}
	},

	validations() {
		return this.validationRules
	},
}
